export default "__VITE_ASSET__471725e2__"